<template>
    <div>
        <div class="table-layout">
            <el-table :data="servcChargeItemList" border style="width: 100%" :height="domHeight">
                <el-table-column prop="servcTypeName" label="服务类型" width="160" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="price" label="参考价格" width="140" align="right" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" width="160"></el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="rows">
                        <a class="swb-btn swb-btn-link" @click="removeItem(rows.row.id)">移除</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--<div class="pagination-layout">-->
        <!--<el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>-->
        <!--</div>-->
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'

    import servcApi from '../../api/servc'

    export default {
        name: 'swb-servc-charge-item-list',
        props: ['msuId'],
        desc: '已关联服务收费项目列表',
        data: function () {
            return {
                servcChargeItemList: [],
            }
        },
        created: function () {
            //
            this.getChargeItemList();
        },
        methods: {
            getChargeItemList: function () {
                let self = this;
                let params = {
                    msuId: this.msuId
                };
                let loading = MsgBox.loading();
                servcApi.getServcChargeItemList(params, function (result) {
                    loading.close();
                    if(result.type === "info") {
                        self.servcChargeItemList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            removeItem: function (id) {
                let self = this;
                this.$confirm('确定要移除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let params = {
                        id: id
                    };
                    let loading = MsgBox.loading();
                    servcApi.deleteServcChargeItem(params, function (result) {
                        loading.close();
                        if(result.type === "info") {
                            self.getChargeItemList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/servc/ServcChargeItemList.vue